@if (desktop) {
  <div class="table" [class.has-subject]="!!subject">
    <div class="header-row">
      <span class="cell cell-name">Wert</span>
      <span class="cell cell-rating">Rating</span>
      <span class="cell cell-potential">Potenzial</span>
      <span class="cell cell-eps">EPS</span>
      <span class="cell cell-surprise">Surprise</span>
      <span class="cell cell-score">Qualität</span>
      <span class="cell cell-score">Wachstum</span>
      <span class="cell cell-score">Dividende</span>
      <span class="cell cell-score">Robustheit</span>
    </div>

    @for (row of rows; track row.isin) {
      <button
        type="button"
        class="data-row"
        [class.subject-row]="row.isSubject"
        [disabled]="!row.zeroLinkIsin"
        [class.no-link]="!row.zeroLinkIsin"
        (click)="onRowClick(row.zeroLinkIsin)"
      >
        <span class="cell cell-name">
          @if (row.icon) {
            <img class="row-icon" [src]="row.icon" [alt]="row.name" loading="lazy" />
          } @else {
            <span class="row-icon row-initials">{{ row.name.slice(0, 2).toUpperCase() }}</span>
          }
          <span class="row-name">{{ row.name }}</span>
        </span>
        <span class="cell cell-rating" [style.color]="'var(' + ratingColorVar(row) + ')'">{{
          row.rating ?? '–'
        }}</span>
        <span class="cell cell-potential" [style.color]="'var(' + potentialColorVar(row) + ')'">{{
          row.potential ?? '–'
        }}</span>
        <span class="cell cell-eps" [style.color]="'var(' + epsLabelColorVar(row) + ')'">{{
          row.epsLabel ?? '–'
        }}</span>
        <span class="cell cell-surprise" [style.color]="'var(' + surpriseColorVar(row) + ')'">{{
          row.surprise ?? '–'
        }}</span>
        @for (score of row.scores; track score.key) {
          <span class="cell cell-score">{{ score.shortDisplay }}</span>
        }
      </button>
    }
  </div>
} @else if (finnetMobile) {
  <div class="group-tabs">
    @for (tab of groupTabs; track tab.key) {
      <button
        type="button"
        class="group-tab"
        [class.active]="isGroupActive(tab.key)"
        (click)="selectGroup(tab.key)"
      >
        {{ tab.label }}
      </button>
    }
  </div>

  <div class="mobile-table" [appV3TabPanel]="activeGroup()">
    <div class="mobile-table-header" [class.scores]="isGroupActive('scores')">
      <span class="mobile-cell mobile-cell-name">Wettbewerber</span>
      @for (metric of headerMetrics(); track metric.key) {
        <span class="mobile-cell" [class.mobile-cell-eps]="metric.key === 'eps'">{{
          metric.label
        }}</span>
      }
    </div>

    @for (row of rows; track row.isin; let i = $index) {
      <button
        type="button"
        class="mobile-table-row"
        [class.alt]="i % 2 === 1"
        [class.scores]="isGroupActive('scores')"
        [disabled]="!row.zeroLinkIsin"
        [class.no-link]="!row.zeroLinkIsin"
        (click)="onRowClick(row.zeroLinkIsin)"
      >
        <span class="mobile-cell mobile-cell-name">
          <span class="row-name">{{ row.name }}</span>
        </span>
        @for (metric of finnetMobileMetricsFor(row); track metric.key) {
          <span
            class="mobile-cell"
            [class.mobile-cell-eps]="metric.key === 'eps'"
            [style.color]="'var(' + metric.colorVar + ')'"
            >{{ metric.value }}</span
          >
        }
      </button>
    }
  </div>
} @else {
  <div class="group-tabs">
    @for (tab of groupTabs; track tab.key) {
      <button
        type="button"
        class="group-tab"
        [class.active]="isGroupActive(tab.key)"
        (click)="selectGroup(tab.key)"
      >
        {{ tab.label }}
      </button>
    }
  </div>

  <div class="rows">
    @for (row of rows; track row.isin) {
      <button
        type="button"
        class="competitor-row"
        [disabled]="!row.zeroLinkIsin"
        [class.no-link]="!row.zeroLinkIsin"
        (click)="onRowClick(row.zeroLinkIsin)"
      >
        @if (row.icon) {
          <img class="row-icon" [src]="row.icon" [alt]="row.name" loading="lazy" />
        } @else {
          <span class="row-icon row-initials">{{ row.name.slice(0, 2).toUpperCase() }}</span>
        }
        <span class="row-name">{{ row.name }}</span>

        <div
          class="row-metrics"
          [class.scores]="isGroupActive('scores')"
          [appV3TabPanel]="activeGroup()"
        >
          @for (metric of metricsFor(row); track metric.key) {
            <div class="metric" [class.metric-rating]="metric.key === 'rating'">
              <span class="metric-label">{{ metric.label }}</span>
              <span class="metric-value" [style.color]="'var(' + metric.colorVar + ')'">{{
                metric.value
              }}</span>
            </div>
          }
        </div>
      </button>
    }
  </div>
}
